import { Link } from 'react-router-dom';
import { Product } from '../types';
import { useFrontendAuth } from '../hooks/useAuth';
import { formatMoney } from '../utils/productValidation';

interface SearchSuggestionProps {
    product: Product;
    onClick: () => void;
}

const SearchSuggestion: React.FC<SearchSuggestionProps> = ({ product, onClick }) => {
    const { user } = useFrontendAuth();
    const thumb = product.imageUrls?.[0];
    const location =
        [product.sellerRegion].filter(Boolean).join(' · ') || null;

    return (
        <Link
            to={`/products/${product.id}`}
            onClick={onClick}
            className="flex min-h-11 items-center gap-3 border-b border-[color-mix(in_srgb,var(--accent-color),transparent_70%)] px-3 py-2.5 last:border-b-0 transition active:bg-[color-mix(in_srgb,var(--accent-color),transparent_75%)] hover:bg-[color-mix(in_srgb,var(--accent-color),transparent_85%)]"
        >
            <div className="h-11 w-11 shrink-0 overflow-hidden rounded-lg bg-[color-mix(in_srgb,var(--accent-color),transparent_80%)]">
                {thumb ? (
                    <img src={thumb} alt="" className="h-full w-full object-cover" />
                ) : (
                    <div className="flex h-full w-full items-center justify-center text-[10px] opacity-40">—</div>
                )}
            </div>
            <div className="min-w-0 flex-1">
                <p className="truncate text-sm font-medium text-[var(--text-color)]">{product.title}</p>
                <p className="truncate text-xs text-[color-mix(in_srgb,var(--text-color),transparent_40%)]">
                    {product.condition}
                    {location ? ` · ${location}` : ''}
                </p>
            </div>
            {user && (
                <span className="shrink-0 text-sm font-semibold text-[var(--text-color)]">
                    €{formatMoney(product.price)}
                </span>
            )}
        </Link>
    );
};

export default SearchSuggestion;